export default __webpack_public_path__ + "static/media/ico-sq-2-hunger.1ae05085.svg";